import BeneficiaryInfoChild from './BeneficiaryInfoChildContainer';

export default BeneficiaryInfoChild;
